const vars = [
  import.meta.env.VITE_APP_MCP_URL,
  import.meta.env.VITE_APP_MCP_CLIENT_ID,
  import.meta.env.VITE_APP_MCP_CLIENT_SECRET,
];

const integrationsCondition = vars.every((item) => item !== undefined && item !== null && item.trim() !== '');

export default integrationsCondition;
